import React from 'react';
import AnnexeHayalBodedPageShell from '../../components/AnnexeHayalBodedPageShell';
import HayalBodedStatic from './HayalBodedStatic';

export default function HayalBoded() {
  return (
    <AnnexeHayalBodedPageShell
      strapiApiId="annexe-hayal-boded"
      defaultSectionLabel="Annexes"
      defaultTitle="Hayal Boded & Salaires"
      defaultTableOneTitle="Salaires soldats"
      defaultTableTwoTitle="Salaires soldats seuls"
      StaticFallback={HayalBodedStatic}
    />
  );
}
